// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { addToChainAfter, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { getDataLayer } from "@pacific/XDL/Utilities/dataLayer";

const _GaDispatchSignIn: typeof DispatchCompleteSignIn = async props => {
    const dataLayer = getDataLayer();
    if (!props.apiResult?.access_token || !dataLayer) {
        return;
    }

    const state = props.getState();
    const session = getSession(state);

    if (session.billToId) {
        await makeHandlerChainAwaitable(loadBillTo)({
            billToId: session.billToId,
        })(props.dispatch, props.getState);
    }

    const affiliation = getBillToState(props.getState(), session.billToId)?.value?.companyName;

    const googleAnalyticsData = {
        event: "login",
        affiliation: affiliation || "",
        authentication_state: "Authenticated",
    };
    dataLayer.push(googleAnalyticsData);
};

addToChainAfter(chain, DispatchCompleteSignIn, _GaDispatchSignIn);
